import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './context/AuthContext'

// Layouts
import AdminLayout from './layouts/AdminLayout'

// Pages
import Login from './pages/Login'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import Dashboard from './pages/Dashboard'
import Users from './pages/Users'
import UserProfile from './pages/UserProfile'
import Subscriptions from './pages/Subscriptions'
import Crm from './pages/Crm'
import CrmOrganisationDetail from './pages/CrmOrganisationDetail'
import Plans from './pages/Plans'
import Tenders from './pages/Tenders'
import TenderDetail from './pages/TenderDetail'
import IngestionLogs from './pages/IngestionLogs'
import Alerts from './pages/Alerts'
import Feedback from './pages/Feedback'
import ServiceTypeAlternativeNames from './pages/ServiceTypeAlternativeNames'
import CommissioningAuthorities from './pages/CommissioningAuthorities'

// CMS — Public Pages
import AboutCmsPage from './pages/cms/AboutPage'
import HomeCmsPage from './pages/cms/HomePage'
import ContactCmsPage from './pages/cms/ContactPage'
import CoverageCmsPage from './pages/cms/CoveragePage'
import FaqCmsPage from './pages/cms/FaqPage'

// CMS — Blog
import BlogsListPage from './pages/cms/BlogsListPage'
import BlogEditorPage from './pages/cms/BlogEditorPage'

// CMS — Legal Pages
import TermsCmsPage from './pages/cms/TermsPage'
import PrivacyCmsPage from './pages/cms/PrivacyPage'
import AffiliateTermsCmsPage from './pages/cms/AffiliateTermsPage'
import SecurityCmsPage from './pages/cms/SecurityPage'
import SLECmsPage from './pages/cms/SLEPage'

// CMS — Site Settings
import SettingsCmsPage from './pages/cms/SettingsPage'

// CMS — Ingestion
import ExclusionKeywordsCmsPage from './pages/cms/ExclusionKeywordsPage'

function ProtectedRoute({ children }) {
    const { isAuthenticated, loading } = useAuth()

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-admin-bg">
                <div className="animate-spin rounded-full h-8 w-8 border-2 border-accent-primary border-t-transparent" />
            </div>
        )
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />
    }

    return children
}

export default function App() {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route
                element={
                    <ProtectedRoute>
                        <AdminLayout />
                    </ProtectedRoute>
                }
            >
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/users" element={<Users />} />
                <Route path="/users/:id" element={<UserProfile />} />
                <Route path="/user-profile/:id" element={<UserProfile />} />
                <Route path="/crm" element={<Crm />} />
                <Route path="/crm/organisations/:id" element={<CrmOrganisationDetail />} />
                <Route path="/subscriptions" element={<Subscriptions />} />
                <Route path="/plans" element={<Plans />} />
                <Route path="/tenders" element={<Tenders />} />
                <Route path="/tenders/:id" element={<TenderDetail />} />
                <Route path="/ingestion" element={<IngestionLogs />} />
                <Route path="/alerts" element={<Alerts />} />
                <Route path="/feedback" element={<Feedback />} />
                <Route path="/service-type-alternative-names" element={<ServiceTypeAlternativeNames />} />
                <Route path="/commissioning-authorities" element={<CommissioningAuthorities />} />

                {/* CMS — Public */}
                <Route path="/cms/home" element={<HomeCmsPage />} />
                <Route path="/cms/about" element={<AboutCmsPage />} />
                <Route path="/cms/contact" element={<ContactCmsPage />} />
                <Route path="/cms/coverage" element={<CoverageCmsPage />} />
                <Route path="/cms/faq" element={<FaqCmsPage />} />

                {/* CMS — Blog */}
                <Route path="/cms/blogs" element={<BlogsListPage />} />
                <Route path="/cms/blogs/new" element={<BlogEditorPage />} />
                <Route path="/cms/blogs/:id" element={<BlogEditorPage />} />

                {/* CMS — Legal */}
                <Route path="/cms/terms" element={<TermsCmsPage />} />
                <Route path="/cms/privacy" element={<PrivacyCmsPage />} />
                <Route path="/cms/affiliate-terms" element={<AffiliateTermsCmsPage />} />
                <Route path="/cms/security" element={<SecurityCmsPage />} />
                <Route path="/cms/sle" element={<SLECmsPage />} />

                {/* CMS — Site Settings */}
                <Route path="/cms/settings" element={<SettingsCmsPage />} />

                {/* CMS — Ingestion */}
                <Route path="/cms/exclusion-keywords" element={<ExclusionKeywordsCmsPage />} />
            </Route>

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
    )
}
